// extracted by mini-css-extract-plugin
export default {"text":"notification_message-module__text--2BkC-","border":"notification_message-module__border--2v2Qh"};